/**
 * Stub implementation for @babel/runtime/helpers/superPropGet
 * This helper is used by packages like @antv/g-lite.
 *
 * Signature: _superPropGet(object, property, receiver, flags)
 * - object: the object to get property from
 * - property: property name/key
 * - receiver: the receiver (this context)
 * - flags: bit flags (1 = use prototype, 2 = bind function)
 */
function _getPrototypeOf(t) {
    return Object.setPrototypeOf
        ? Object.getPrototypeOf(t)
        : t.__proto__ || Object.getPrototypeOf(t);
}

function _superPropBase(object, property) {
    while (!{}.hasOwnProperty.call(object, property) && object !== null) {
        object = _getPrototypeOf(object);
    }
    return object;
}

function _get(object, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) {
        return Reflect.get(object, property, receiver);
    }
    var base = _superPropBase(object, property);
    var desc = Object.getOwnPropertyDescriptor(base, property);
    if (desc) {
        if (desc.get) {
            return desc.get.call(receiver !== undefined ? receiver : object);
        }
        return desc.value;
    }
    return undefined;
}

function _superPropGet(t, o, e, r) {
    var p = _get(
        r & 1 ? _getPrototypeOf(t.prototype) : _getPrototypeOf(t),
        o,
        e,
    );
    return r & 2 && typeof p === "function"
        ? function (t) {
              return p.apply(e, t);
          }
        : p;
}

module.exports = _superPropGet;
module.exports.__esModule = true;
module.exports["default"] = module.exports;
